var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.contacts, function(contact) {
      return _c("organisation-contact-control", {
        key: contact.contactId,
        staticClass: "mb-3",
        attrs: {
          title: _vm.displayPath(contact.type),
          item: contact.contact,
          isReadOnly: true
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }